import { HotspotStyle } from '../../HotspotStyle';
import { isLocatedOnPanoramaActiveView } from '../../../utils/isLocatedOnPanoramaActiveView';
/**
 * Function that renders TeleportArrow to panorama
 */
export function renderTeleportArrow(panorama, arrow, arrowIdentifier, renderOptions) {
    if (!isLocatedOnPanoramaActiveView(panorama, arrow.sceneIndex, arrow.tourSceneGuid)) {
        return;
    }
    const arrowPosition = arrow.arrowPositionConfiguration.arrowPosition;
    // Order of the calls is important here, if 'loadStyle' is called after 'visible'
    // is set then hotspot is not displayed
    const hotspot = panorama._pano.addHotspot(arrowIdentifier);
    hotspot.loadstyle(HotspotStyle.HotspotTeleportArrow);
    hotspot.ath = arrowPosition.xAxis;
    hotspot.atv = arrowPosition.yAxis;
    hotspot.visible = true;
    hotspot.enabled = true;
    if (renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.onClick) {
        hotspot.onclick = renderOptions.onClick;
    }
}
